// Azure Entra B2C Authentication configuration (environment driven)
// All values can be overridden via .env.* file (see .env.example)
const domain = process.env.REACT_APP_B2C_DOMAIN ;
const tenant = process.env.REACT_APP_B2C_TENANT ;
const policySignUpSignIn = process.env.REACT_APP_B2C_POLICY_SIGNUPSIGNIN ;
const policyPasswordReset = process.env.REACT_APP_B2C_POLICY_PASSWORDRESET ;
const policyProfileEdit = process.env.REACT_APP_B2C_POLICY_PROFILEEDIT;

const b2cPolicies = {
  names: {
    signUpSignIn: policySignUpSignIn,
    resetPassword: policyPasswordReset,
    editProfile: policyProfileEdit
  },
  authorities: {
    signUpSignIn: {
      authority: `https://${domain}/${tenant}/${policySignUpSignIn}`,
    },
    resetPassword: {
      authority: `https://${domain}/${tenant}/${policyPasswordReset}`,
    },
    editProfile: {
      authority: `https://${domain}/${tenant}/${policyProfileEdit}`,
    },
  },
  authorityDomain: domain
};

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_CLIENT_ID || '213ef195-5284-4ddc-9fa0-82f3d3631b18', // B2C Application client ID
    authority: b2cPolicies.authorities.signUpSignIn.authority, 
    knownAuthorities: [b2cPolicies.authorityDomain], // Known authorities for B2C
    redirectUri: window.location.origin, // Use current origin as redirect URI
    postLogoutRedirectUri: window.location.origin, // Use current origin as post-logout redirect URI
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to true for Internet Explorer support
  }
};

// Add scopes for token request
// For accessing B2C protected resources
const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access']
};

// Simplified request for ID token
const apiRequest = {
  scopes: ['openid', 'profile']  // These scopes are for getting an ID token
};

export { msalConfig, loginRequest, apiRequest, b2cPolicies };
